/**
 * Replace {key} placeholders in a translated string.
 * Usage: ct('cabin.dashboard.greeting', { name: 'Sprit' })
 */
export function interpolate(str, params = {}) {
  if (!str || !params) return str;
  return Object.keys(params).reduce((acc, key) => {
    return acc.replace(new RegExp(`\\{${key}\\}`, 'g'), params[key]);
  }, str);
}

/**
 * Level data based on miles
 */
export const LEVEL_TABLE = [
  { order: 1, key: 'beginner',     minMiles: 0,    maxMiles: 100,  emoji: '🌱' },
  { order: 2, key: 'student',      minMiles: 100,  maxMiles: 300,  emoji: '📚' },
  { order: 3, key: 'candidate',    minMiles: 300,  maxMiles: 600,  emoji: '✈️' },
  { order: 4, key: 'intermediate', minMiles: 600,  maxMiles: 1000, emoji: '🎯' },
  { order: 5, key: 'advanced',     minMiles: 1000, maxMiles: 1500, emoji: '⭐' },
  { order: 6, key: 'expert',       minMiles: 1500, maxMiles: 2500, emoji: '🏆' },
  { order: 7, key: 'master',       minMiles: 2500, maxMiles: 4000, emoji: '👑' },
  { order: 8, key: 'professional', minMiles: 4000, maxMiles: Infinity, emoji: '💎' },
];

export function getLevelFromMiles(miles) {
  return LEVEL_TABLE.find(
    (l) => miles >= l.minMiles && miles < l.maxMiles
  ) || LEVEL_TABLE[LEVEL_TABLE.length - 1];
}

export function getLevelProgress(miles) {
  const level = getLevelFromMiles(miles);
  if (level.maxMiles === Infinity) return 100;
  const range = level.maxMiles - level.minMiles;
  const earned = miles - level.minMiles;
  return Math.min(100, Math.round((earned / range) * 100));
}

/**
 * Milestone data (overall course progress based)
 */
export const MILESTONES = [
  { key: 'beginner',     pct: 0,   emoji: '🌱' },
  { key: 'student',      pct: 25,  emoji: '📚' },
  { key: 'practitioner', pct: 50,  emoji: '✈️' },
  { key: 'master',       pct: 75,  emoji: '🎖️' },
  { key: 'expert',       pct: 100, emoji: '👨‍✈️' },
];

export function getCurrentMilestone(overallPct) {
  const passed = MILESTONES.filter((m) => overallPct >= m.pct);
  return passed[passed.length - 1] || MILESTONES[0];
}
